module.exports = __webpack_public_path__ + "static/markus-spiske-445251-unsplash-223feefaabd25ab4d80591b3f7b942b3.jpg";